/**
 * @module actions/evaluationhistory
 */
import axios from 'axios'
import { API_URL } from '../constants'

/**
 * @description Get evaluation history from api
 * @return {Promise} Axios promise
 */
export function getEvaluationHistory (orderId) {
  let url = API_URL + '/EvaluationHistory/Get/' + orderId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Update evaluation history changes to api
 * @return {Promise} Axios promise
 */
export function updateEvaluationHistory (data) {
  let url = API_URL + '/EvaluationHistory/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/evaluationhistory.js